const resetPageScroll = (documentRef = document, windowRef = window) => {
  if (typeof documentRef === "undefined" || typeof windowRef === "undefined") {
    return
  }

  const applyReset = () => {
    const root = documentRef.scrollingElement || documentRef.documentElement || documentRef.body
    const scrollTargets = []

    if (root) {
      scrollTargets.push(root)
    }

    const containerSelectors = [
      ".ant-modal-body",
      ".ant-drawer-body",
      ".modal-body",
      "[data-scroll-container]",
    ]

    containerSelectors.forEach((selector) => {
      documentRef.querySelectorAll(selector).forEach((element) => {
        if (element && typeof element.scrollTo === "function") {
          scrollTargets.push(element)
        }
      })
    })

    const scrollableElements = Array.from(documentRef.querySelectorAll("*"))
      .filter((element) => {
        const isElementLike = Boolean(element) && typeof element === "object" && (
          typeof element.scrollHeight === "number" ||
          typeof element.clientHeight === "number" ||
          typeof element.scrollTo === "function"
        )

        if (!isElementLike) {
          return false
        }

        const style = windowRef.getComputedStyle(element)
        const overflowY = style.overflowY
        const overflowX = style.overflowX
        const isScrollable =
          (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay") ||
          (overflowX === "auto" || overflowX === "scroll" || overflowX === "overlay")

        return isScrollable && (element.scrollHeight > element.clientHeight + 1 || element.scrollWidth > element.clientWidth + 1)
      })

    scrollableElements.forEach((element) => {
      if (!scrollTargets.includes(element)) {
        scrollTargets.push(element)
      }
    })

    scrollTargets.forEach((target) => {
      if (target && typeof target.scrollTo === "function") {
        target.scrollTo({ top: 0, left: 0, behavior: "auto" })
      }

      if (target) {
        target.scrollTop = 0
        target.scrollLeft = 0
      }
    })

    if (typeof windowRef.scrollTo === "function") {
      windowRef.scrollTo({ top: 0, left: 0, behavior: "auto" })
    }
  }

  applyReset()

  if (typeof windowRef.requestAnimationFrame === "function") {
    windowRef.requestAnimationFrame(() => applyReset())
  }

  if (typeof windowRef.setTimeout === "function") {
    windowRef.setTimeout(() => applyReset(), 50)
  }
}

module.exports = resetPageScroll
module.exports.default = resetPageScroll
